import { KRAKOW_OFFICE_ID } from 'domain/shared/employee';
import { EMPLOYEE_DOCUMENT_SECTIONS } from '../constants';

export default {
  office: { type: 'enum', required: true },
  section: { type: 'enum', required: true },
  fileType: { type: 'enum', required: true },
  stage: { type: 'enum', required: true },
  category: {
    type: 'string',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $office: {
              in: [String(KRAKOW_OFFICE_ID), KRAKOW_OFFICE_ID],
            },
          },
          {
            $section: {
              ne: EMPLOYEE_DOCUMENT_SECTIONS.OTHER,
            },
          },
          {
            $isPolishContractEmployee: {
              eq: true,
            },
          },
        ],
      },
    },
  },
  number: {
    type: 'string',
    required: {
      value: true,
      when: {
        $section: {
          eq: EMPLOYEE_DOCUMENT_SECTIONS.HR,
        },
      },
    },
  },
  paths: {
    type: 'array',
    maxSize: 1,
    required: true,
  },
};
